// Kunlik nuqtalarni grafik uchun haftalik ustunlarga guruhlaydi.
// Backendga qo'shimcha so'rov yubormaydi — mavjud kunlik ma'lumotni
// mijoz tomonida 7 kunlik bo'laklarga bo'ladi (oxiridan boshlab tekislanadi),
// natijada ~30 kun uchun 4-5 ta o'qiladigan ustun chiqadi.

export type Bucket = { label: string; count: number };

// "2026-06-15" -> "15.06" (lokalsiz, qisqa o'q yorlig'i)
function shortLabel(iso: string): string {
  const parts = iso.split("-");
  if (parts.length < 3) return iso;
  return `${parts[2]}.${parts[1]}`;
}

export function bucketByWeek(
  points: { date: string; count: number }[],
): Bucket[] {
  if (points.length === 0) return [];
  const buckets: Bucket[] = [];
  for (let end = points.length; end > 0; end -= 7) {
    const start = Math.max(0, end - 7);
    const slice = points.slice(start, end);
    const count = slice.reduce((s, p) => s + p.count, 0);
    buckets.unshift({ label: shortLabel(slice[0].date), count });
  }
  return buckets;
}
